document.addEventListener('DOMContentLoaded', function() {
  if (typeof timber !== 'undefined') {
    timber.alignMenu = function () {
      // Disabled: prevent nav items from collapsing into "More" dropdown
    };
  }
});
